<template>
  <div class="starter-kit" :class="{inline}">

    <div class="sidebar">
      <i class="material-icons nav back visible-phone" @click="handleBack">keyboard_arrow_left</i>

      <div class="items">
        <a class="item"
           v-for="(item, index) in platforms"
           :key="item.id"
           :class="{active: index === tab}"
           @click="handleSidebar(index)"
        >
          {{ item.title }} ({{ item.count }})
        </a>
      </div>

      <i class="material-icons nav next visible-phone" @click="handleNext">keyboard_arrow_right</i>
    </div>

    <div class="content">
      <div class="items">
        <starter-kit-item
          v-for="(item, index) in starterKits"
          :key="index"
          :styleRuleId="styleRuleId"
          :colors="colors"
          :previewUrl="isScreen ? styleAssets[index]['source-url'] : undefined"
          :starterKit="starterKits[index]"
          :onPreview="() => onPreview(index)"
          :onDownload="(format) => isScreen ? {} : onDownload(index, format)"
          :isSketch="isScreen ? false : checkFormatAvailable(item, 'sketch')"
          :isFigma="isScreen ? false : checkFormatAvailable(item, 'figma')"
          :isStudio="isScreen ? false : checkFormatAvailable(item, 'studio')"
          :isXd="isScreen ? false : checkFormatAvailable(item, 'xd')"
          :inline="inline"
          :isScreen="isScreen"
        />
      </div>
    </div>

  </div>
</template>

<script>
import StarterKitItem from './StarterKitItem';

export default {
  name: 'starter-kit',
  components: {
    StarterKitItem,
  },
  props: {
    inline: Boolean,
    onPreview: Function,
    onTab: Function,
    onDownload: Function,
    starterKits: Array,
    platforms: Array,
    tab: Number,
    styleAssets: Array,
    styleRuleId: String,
    colors: Array,
    backgrounds: Number,
    isScreen: Boolean,
  },
  data() {
    return {
      items: new Array(5),
    };
  },
  methods: {
    handleSidebar(index) {
      this.onTab(index);
    },
    handleBack() {
      this.onTab((this.tab - 1 < 0) ? this.platforms.length - 1 : this.tab - 1);
    },
    handleNext() {
      this.onTab((this.tab + 1 >= this.platforms.length) ? 0 : this.tab + 1);
    },
    checkFormatAvailable(curStarterKit, format) {
      let designFileId = -1;
      let maxBgNum = 0;
      let maxBgId = -1;
      for (let i = 0; i < curStarterKit['design-files'].length; i++) {
        if (maxBgNum < curStarterKit['design-files'][i].bgs) {
          maxBgNum = curStarterKit['design-files'][i].bgs;
          maxBgId = i;
        }

        if (this.backgrounds === curStarterKit['design-files'][i].bgs) {
          this.designFileId = i;
          break;
        }
      }

      if (designFileId === -1) {
        designFileId = maxBgId;
      }
      const { files } = curStarterKit['design-files'][designFileId];
      for (let i = 0; i < files.length; i++) {
        if (files[i].format === format) {
          return true;
        }
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
  .starter-kit {
    @include media($notMobile) {
      display: flex;
    }

    &.inline {
      .sidebar {
        .items {
          top: 0;
        }
      }
    }
  }

  .menu {
    text-align: center;
    margin-bottom: 15px;

    a {
      display: inline-flex;
      align-items: center;
    }

    i {
      margin-right: 10px;
    }
  }

  .sidebar {
    position: relative;

    @include media($notMobile) {
      width: 240px;
      margin-right: 40px;
    }

    @include media($tabletOnly) {
      width: 200px;
      margin-right: 15px;
    }

    @include media($mobile) {
      margin-bottom: 15px;
      text-align: center;
    }

    .nav {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
    }

    .back {
      left: 0;
    }

    .next {
      right: 0;
    }

    .items {
      @include media($notMobile) {
        position: sticky;
        top: 50px;
      }
    }

    .item {
      display: block;
      opacity: .5;
      padding: 12px;
      color: $dark;

      &:hover, &.active {
        opacity: 1;
      }

      @include media($notMobile) {
        &.active {
          box-shadow: 0 14px 19px rgba(black, .08);
        }
      }

      @include media($mobile) {
        opacity: 1;

        &:not(.active) {
          display: none;
        }
      }
    }
  }

  .content {
    flex: 1;
  }
</style>
